export const PORTWISE_CONTAINER_REPORT_COLUMN = [
    {
        Header: "MODULE NAME",
        accessor: "DataOf",
    },
    {
        Header: "PORT NAME",
        accessor: "Port_Of_Destination",
    },
    {
        Header: "CONTAINER COUNT",
        accessor: "Container_Count",
    },
]

export const CARRIERWISE_CONTAINER_REPORT_COLUMN = [
    {
        Header: "MODULE NAME",
        accessor: "DataOf",
    },
    {
        Header: "CARRIER",
        accessor: "Carrier",
    },
    {
        Header: "CONTAINER COUNT",
        accessor: "Container_Count",
    },
]